import pt from './pt';

export default { pt };
